import { useState, useEffect } from "react";

export default function AdvertisementSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(0);

  const slides = [
    { id: 1, bg: "bg-orange-50" },
    { id: 2, bg: "bg-yellow-50" },
    { id: 3, bg: "bg-green-50" },
    { id: 4, bg: "bg-blue-50" },
  ];

  // Track window width for responsive carousel
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto scroll
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Calculate slide width and gap based on screen size
  const isDesktop = windowWidth >= 1024;
  const slideWidth = isDesktop ? 70 : 85;
  const gapSize = isDesktop ? 24 : 12;

  return (
    <section style={{ 
      backgroundColor: "#FEF2F2",
      paddingTop: 'clamp(24px, 2.08vw, 40px)',
      paddingBottom: 'clamp(24px, 2.08vw, 40px)',
      paddingLeft: 'clamp(16px, 1.25vw, 24px)',
      paddingRight: 'clamp(16px, 1.25vw, 24px)'
    }}>
      <div className="mx-auto" style={{ maxWidth: '1920px', margin: '0 auto' }}>
        {/* Carousel Container */}
        <div className="relative overflow-hidden">
          <div
            className="flex gap-3 sm:gap-4 md:gap-5 lg:gap-6 transition-transform duration-700 ease-out"
            style={{
              transform: `translateX(calc(-${currentIndex * slideWidth}% - ${currentIndex * gapSize}px))`,
            }}
          >
            {slides.map((slide) => (
              <div
                key={slide.id}
                className={`flex-shrink-0 ${slide.bg} rounded-xl sm:rounded-2xl`}
                style={{
                  width: `${slideWidth}%`,
                  aspectRatio: "863/238",
                  minWidth: `${slideWidth}%`,
                }}
              >
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src={`/api/placeholder/863/238`}
                    alt={`Slide ${slide.id}`}
                    className="w-full h-full object-cover rounded-xl sm:rounded-2xl"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Square Indicators */}
        <div className="flex justify-center mt-4 sm:mt-5 md:mt-6 lg:mt-8 gap-1.5 sm:gap-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 rounded-full transition-colors ${
                currentIndex === index ? "bg-gray-700" : "bg-gray-300"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
